export const MODAL_IDS_MAP = {
  CHAT: 'chat',
  SHARE: 'share',
  NEGATIVE_FEEDBACK: 'negativeFeedback',
  COMPENSATION_VISIBILITY: 'compensationVisibility',
  CURRICULUM: 'curriculum',
};
